import React, { Component } from 'react';
import { Button, Form, Input, Segment, Grid, Label, Message } from 'semantic-ui-react'

export class EnrollmentOtherDetails extends Component {
  state = {
    haveErrors: false,
    message: '',
    error: {
      email: false,
      mobile1: false,
      address: false,
      contactPerson: false,
      contactPersonNumber: false,
      contactPersonAddress: false,
    },
  }

  continue = e => {
    e.preventDefault();
    if(this.handleValidation()) {
      this.setState({haveErrors: false})
      this.props.nextStep();
    } else {
      this.setState({haveErrors: true})
    }
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  validateEmail = (email) => {
   if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)){
      return true
    }
    return false
  }

  handleValidation = () => {
    let hasValidationErrors = false;
    const { values } = this.props;
    const { error } = this.state;
    if(values.email === '') {
      error.email = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      if (this.validateEmail(values.email)) {
        error.email = false;
        this.setState({
          error
        })
      } else {
        error.email = true;
        console.log('')
        this.setState({
          error,
          message: 'Please enter a valid email address.'
        })
        hasValidationErrors = true;
      }
    }

    if(values.mobile1 === '') {
      error.mobile1 = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      error.mobile1 = false;
      this.setState({
        error
      })
    }

    if(values.address === '') {
      error.address = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      error.address = false;
      this.setState({
        error
      })
    }

    if(values.contactPerson === '') {
      error.contactPerson = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      error.contactPerson = false;
      this.setState({
        error
      })
    }

    if(values.contactPersonNumber === '') {
      error.contactPersonNumber = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      error.contactPersonNumber = false;
      this.setState({
        error
      })
    }

    if(values.contactPersonAddress === '') {
      error.contactPersonAddress = true;
      this.setState({
        error,
        message: 'Required fields must not be blank.'
      })
      hasValidationErrors = true;
    } else {
      error.contactPersonAddress = false;
      this.setState({
        error
      })
    }

    if (hasValidationErrors) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { values, handleChange } = this.props;
    return (
      <Segment className='enrollment-form-segment'>
        <h1>Contact Details</h1>
        {
          this.state.haveErrors &&
          <Message
            error
            content={this.state.message}
          />
        }
        <Form>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.email}>
              <label>Email</label>
              <Input value={values.email} name='email' placeholder='Email' onChange={handleChange} />
              <Label pointing>Please make sure to enter a working email address. We will use this to send the assessment of fees.</Label>
            </Form.Field>
            <Form.Field required error={this.state.error.mobile1} control={Input} value={values.mobile1} name='mobile1' label='Mobile Number 1' placeholder='Mobile Number 1' onChange={handleChange}/>
            <Form.Field control={Input} value={values.mobile2} name='mobile2' label='Mobile Number 2' placeholder='Mobile Number 2' onChange={handleChange}/>
          </Form.Group>
          <Form.Field required error={this.state.error.address} value={values.address} name='address' control={Input} label='Address' placeholder='Address' onChange={handleChange}/>
          <h4> Contact Person in case of Emergency</h4>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.contactPerson} control={Input} value={values.contactPerson} name='contactPerson' label='Name' placeholder='Name' onChange={handleChange}/>
            <Form.Field required error={this.state.error.contactPersonNumber} control={Input} value={values.contactPersonNumber} name='contactPersonNumber' label='Contact Number' placeholder='Contact Number' onChange={handleChange}/>
            <Form.Field required error={this.state.error.contactPersonAddress} control={Input} value={values.contactPersonAddress} name='contactPersonAddress' label='Address' placeholder='Address' onChange={handleChange}/>
          </Form.Group>
        </Form>
        <Grid>
          <Grid.Column width={8}>

          </Grid.Column>
          <Grid.Column width={8} textAlign='right'>
            <Button onClick={this.back}>Back</Button>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>

      </Segment>
    );
  }
}

export default EnrollmentOtherDetails;
